export function PointsBadge({
  points,
}: {
  points: number
}) {
  const background = getBackgroundForPoints(points)
  const textColor = points >= 10 ? '#000000' : getTextColor(background)

  return (
    <span
      className="inline-flex min-w-[1.9rem] items-center justify-center rounded-lg px-1.5 py-0.5 text-xs font-bold"
      style={{
        backgroundColor: background,
        color: textColor,
      }}
    >
      {points}
    </span>
  )
}

function getBackgroundForPoints(points: number) {
  if (points <= 0) return '#ef4444'
  if (points === 1) return '#f97316'
  if (points >= 5 && points <= 6) return '#2E7D32'
  if (points >= 7 && points <= 9) return '#22c55e'
  if (points >= 10) return '#6ee7b7'
  return '#374151'
}

function getTextColor(background: string) {
  const normalized = background.replace('#', '')
  const hex = normalized.length === 3
    ? normalized
      .split('')
      .map((char) => `${char}${char}`)
      .join('')
    : normalized

  const red = parseInt(hex.slice(0, 2), 16)
  const green = parseInt(hex.slice(2, 4), 16)
  const blue = parseInt(hex.slice(4, 6), 16)
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255

  return luminance > 0.5 ? '#000000' : '#FFFFFF'
}
